import { defineComponent as _defineComponent } from 'vue'
import { LoaderIndicator } from '@warrenbrasil/nebraska-web';
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import {
  getThemeByParam,
  instantLogin,
  InstantLoginResponse
} from '@/modules/common/services/http/account';
import { impersonateCustomer } from '@/modules/common/services/impersonate-customer';
import {
  IUserB2B,
  setCustomTheme,
  setUserB2B,
  StorageKeys
} from '@/modules/common/services/local-storage';
import { setLoggedUser } from '@/modules/common/views/InstantLogin/helpers/setLoggedUser';
import { setNebraskaScheme } from '@/modules/common/services/theme';
import { CustomerModule } from '@/modules/common/store/CustomerModule';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { notify } from '@/modules/common/helpers/notification';
import { getString } from '@/modules/common/helpers/resources';
import { NotificationTypes } from '@/modules/common/services/http/notification';


export default /*#__PURE__*/_defineComponent({
  __name: 'InstantLoginFlow',
  setup(__props) {

const router = useRouter();
const route = useRoute();

function redirect(name = 'home') {
  router.push({ name, query: route.query });
}

function goToSignIn() {
  setTimeout(() => {
    redirect('signin');
  }, 2000);
}

function setPartner({ user, brand, accessToken }: InstantLoginResponse) {
  localStorage.setItem(StorageKeys.Brand, JSON.stringify(brand));
  localStorage.setItem(StorageKeys.ForceWrnUserUpdate, 'true');
  localStorage.setItem(StorageKeys.AccessToken, accessToken);
  localStorage.setItem(StorageKeys.IsPartnerAccountSession, 'true');
  setUserB2B(user as IUserB2B);
}

function setCustomer(customer: InstantLoginResponse) {
  const accessToken: string =
    localStorage.getItem(StorageKeys.ImpersonateToken) || '';
  if (accessToken) localStorage.removeItem(StorageKeys.ImpersonateToken);
  setLoggedUser(customer);
  localStorage.setItem(StorageKeys.CustomerId, customer.user._id!);
  localStorage.setItem(StorageKeys.ImpersonateToken, customer.accessToken);
}

async function setTheme(email: string) {
  const theme = await getThemeByParam('email', email);
  setNebraskaScheme(theme);
  setCustomTheme(theme);
}

async function fetchLoginHashes(customerHash: string, partnerHash: string) {
  return Promise.all([
    instantLogin({ hash: customerHash }),
    instantLogin({ hash: partnerHash })
  ]);
}

async function fetchCustomerModule(partnerEmail: string) {
  return Promise.all([
    CustomerModule.fetchCustomer(),
    FeatureFlagsModule.fetchFeatureFlags(),
    setTheme(partnerEmail)
  ]);
}

async function handleInstantLogin() {
  const partnerHash = route.params.partnerHash;
  const customerHash = route.params.customerHash;
  try {
    const [customer, partner] = await fetchLoginHashes(
      customerHash,
      partnerHash
    );
    setCustomer(customer);
    setPartner(partner);
    await impersonateCustomer(customer.user._id);
    await fetchCustomerModule(partner.user.email);
    redirect(route.query.page as string);
  } catch (err) {
    const baseError = err as Error;
    notify({
      group: 'wrn-notifications',
      title: getString(baseError.message) ?? baseError.message,
      type: NotificationTypes.error
    });
    goToSignIn();
  }
}
onMounted(handleInstantLogin);

return { __sfc: true,router, route, redirect, goToSignIn, setPartner, setCustomer, setTheme, fetchLoginHashes, fetchCustomerModule, handleInstantLogin, LoaderIndicator }
}

})